'use client'
import { useRef } from 'react'
import { useSearchCriteriaStore } from './useSearchCriteriaStore'
import type { ResultDisplay } from '@/domains/agenceSite/agenceSite.types'
import { getResultDisplay } from '@/domains/agenceSite/agenceSite.utils'
import { useEstimateFormStore } from './useEstimateFormStore'

export function StoreInitializer({
  formatAffichage,
  activerServiceAchat
}: {
  formatAffichage: ResultDisplay,
  activerServiceAchat: boolean
}) {
  const initialized = useRef(false)
  if (!initialized.current) {
    useSearchCriteriaStore.setState(getResultDisplay(formatAffichage))
    useEstimateFormStore.setState({
      type: activerServiceAchat ? 'sell' : 'rent',
    })
    initialized.current = true
  }
  return null
}
